<template>
  <div :class="$style.page">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="实名认证" name="first">
        <Loading :loading="loading">
          <div :class="$style.content">
            <div :class="$style.item">
              <div :class="$style.left">
                <img
                  :class="$style.img"
                  src="@assets/image/safe-people.png"
                  alt=""
                />
                <div :class="$style.info">
                  <div :class="$style.info_title">实名认证</div>
                  <div :class="$style.info_con">
                    <span :class="$style.username" v-show="userInfo.username">{{
                      userInfo.username
                    }}</span>
                    {{ getStatusText(authStatus) }}
                  </div>
                  <div></div>
                </div>
              </div>
              <div :class="$style.right">
                <div
                  v-if="authStatus == -1 || authStatus == 2"
                  :class="$style.btn"
                  @click="jumpPage('/user/safe-name')"
                >
                  认证
                </div>
              </div>
            </div>
            <div :class="$style.item">
              <div :class="$style.left">
                <img
                  :class="$style.img"
                  src="@assets/image/safe-lock.png"
                  alt=""
                />
                <div :class="$style.info">
                  <div :class="$style.info_title">登录密码</div>
                  <div :class="$style.info_con">
                    {{ hasPwd === 1 ? "已设置" : "未设置" }}
                  </div>
                  <div></div>
                </div>
              </div>
              <div :class="$style.right">
                <div :class="$style.btn" @click="jumpPage('/user/safe-pwd')">
                  {{ hasPwd === 1 ? "修改" : "设置" }}
                </div>
              </div>
            </div>
            <div :class="$style.item">
              <div :class="$style.left">
                <img
                  :class="$style.img"
                  src="@assets/image/safe-email.png"
                  alt=""
                />
                <div :class="$style.info">
                  <div :class="$style.info_title">账户邮箱</div>
                  <div :class="$style.info_con">
                    {{ !!email ? email : "未设置" }}
                  </div>
                  <div></div>
                </div>
              </div>
              <div :class="$style.right">
                <div
                  :class="$style.btn"
                  @click="jumpPage('/user/email-update')"
                >
                  {{ !!email ? "修改" : "设置" }}
                </div>
              </div>
            </div>
            <div :class="$style.item">
              <div :class="$style.left">
                <img
                  :class="$style.img"
                  src="@assets/image/safe-phone.png"
                  alt=""
                />
                <div :class="$style.info">
                  <div :class="$style.info_title">绑定手机</div>
                  <div :class="$style.info_con">{{ mobile }}</div>
                  <div></div>
                </div>
              </div>
              <div :class="$style.right">
                <div :class="$style.btn" @click="jumpPage('/user/safe-phone')">
                  修改
                </div>
              </div>
            </div>
          </div>
        </Loading>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getSafeInfo } from "@server";

export default {
  name: "SafeCenter",
  data() {
    return {
      activeName: "first",
      loading: false,

      authStatus: -1,
      hasPwd: "",
      email: "",
      mobile: "",
    };
  },
  computed: {
    ...mapState("user", ["userInfo"]),
  },
  methods: {
    async getSafeInfo() {
      this.loading = true;
      const res = await getSafeInfo();
      const { code, data } = res;

      if (code === 200) {
        this.authStatus = data.authStatus;
        this.hasPwd = data.hasPwd;
        this.email = data.email;
        this.mobile = data.mobile;
      }
      this.loading = false;
    },

    getStatusText(status) {
      const mapStatus = {
        "-1": "未认证",
        0: "认证中",
        1: "认证成功",
        2: "认证失败",
      };

      return mapStatus[status];
    },

    jumpPage(link) {
      this.$router.push(link);
      document.querySelector("#user-page").scrollIntoView();
    },
  },
  created() {
    this.getSafeInfo();
  },
};
</script>

<style lang="scss" module scoped>
.page {
  :global {
    ::v-deep .el-tabs {
      .el-tabs__content {
        min-height: 300px;
      }
    }
  }

  .content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 50px;
  }

  .item {
    flex: 1;
    min-width: 40%;
    padding: rem(40) rem(50);
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f7f7fa;

    .left {
      display: flex;
      align-items: center;

      .img {
        height: rem(44);
        margin-right: rem(30);
        object-fit: cover;
      }

      .info {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: rem(44);
        font-weight: bold;
      }

      .info_title {
        font-size: rem(16);
        color: #333;
        margin-bottom: 3px;
      }

      .info_con {
        font-size: rem(14);
        color: $theme-color;
      }

      .username {
        color: #333;
        margin-right: rem(30);
      }
    }
  }

  .btn {
    width: rem(90);
    height: rem(48);
    font-size: rem(14);
    font-weight: bold;
    color: $theme-color;
    line-height: rem(48);
    text-align: center;
    background-color: $white;
    border: 1px solid $theme-color;
    transition: all 0.24s;
    cursor: pointer;

    &:hover {
      background-color: #feede8;
    }
  }
}
</style>
